export const environment = {
  production: true,
  nombre:null,
  url:"https://backend.telepagos.com.ar/api/",
  urlDescarga:"https://backend.telepagos.com.ar/"
};
